import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import omit from 'lodash.omit';

import Input from '../../../../../../../../Input';
import {
  getInchMeasurements,
  getPercentMeasurements,
} from '../../../../../CardDesignerCardElementFrame/helpers';
import { ORIENTATION } from '../../../../../../../../../../services/cards/constants';

const propTypes = {
  element: PropTypes.shape({
    cardElement: PropTypes.shape({
      frame: PropTypes.shape({
        width: PropTypes.number,
        height: PropTypes.number,
      }),
      z_index: PropTypes.number,
    }),
  }),
  cardPrintSize: PropTypes.shape({
    id: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  cardOrientation: PropTypes.oneOf(Object.values(ORIENTATION)),
  onCardElementUpdate: PropTypes.func.isRequired,
};

const CardDesignerCardElementMeasurementControls = ({
  element,
  cardPrintSize,
  cardOrientation,
  onCardElementUpdate,
}) => {
  const { frame } = element.cardElement;
  const [width, setWidth] = useState();
  const [height, setHeight] = useState();
  const inchMeasurements = useMemo(
    () => getInchMeasurements(frame, cardPrintSize, cardOrientation),
    [frame],
  );

  useEffect(() => {
    setWidth(inchMeasurements?.width ?? 0);
    setHeight(inchMeasurements?.height ?? 0);
  }, [frame]);

  return (
    <div className="card-designer-card-element-measurement-controls">
      <div className="measurement-div">
        <Input
          id="border-width"
          type="number"
          max={inchMeasurements.maxWidth}
          min={0}
          step={0.01}
          value={width}
          onChange={({ target }) => {
            const inchWidth = Math.min(
              inchMeasurements.maxWidth,
              target.value ?? 0,
            );

            const { width: percentWidth } = getPercentMeasurements(
              inchWidth,
              height,
              cardPrintSize,
              cardOrientation,
            );
            setWidth(target.value ? inchWidth : undefined);

            if (!inchWidth) {
              return;
            }

            onCardElementUpdate({
              cardElement: element.cardElement,
              data: {
                frame: {
                  ...omit(frame, '__typename'),
                  width: percentWidth,
                },
              },
            });
          }}
        />
      </div>
      &nbsp; &times; &nbsp;
      <div className="measurement-div">
        <Input
          id="border-height"
          type="number"
          max={inchMeasurements.maxHeight}
          min={0}
          step={0.01}
          value={height}
          onChange={({ target }) => {
            const inchHeight = Math.min(
              inchMeasurements.maxHeight,
              target.value ?? 0,
            );
            const { height: percentHeight } = getPercentMeasurements(
              width,
              inchHeight,
              cardPrintSize,
              cardOrientation,
            );
            setHeight(target.value ? inchHeight : undefined);

            if (!inchHeight) {
              return;
            }

            onCardElementUpdate({
              cardElement: element.cardElement,
              data: {
                frame: {
                  ...omit(frame, '__typename'),
                  height: percentHeight,
                },
              },
            });
          }}
        />
      </div>
    </div>
  );
};

CardDesignerCardElementMeasurementControls.propTypes = propTypes;

export default CardDesignerCardElementMeasurementControls;
